import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export function handleError(error: any, instance: IPublicClientApplication, request: { account?: AccountInfo, scopes: string[] }) {
    console.error(error);
}
